import { createSelector } from '@reduxjs/toolkit';

import type { SliceStateFromReducer } from 'shared/types';

import type { pledgeEstateFormSlice } from 'entities/pledgeEstateForm';

export type TPledgeEstateState = SliceStateFromReducer<typeof pledgeEstateFormSlice>;

export const selectPledgeFormInfo = (state: TPledgeEstateState) => state.pledgeEstateForm;

export const selectPledgeEstateData = (state: TPledgeEstateState) => {
  if (!state.pledgeEstateForm.data) {
    return state.pledgeEstateForm.defaults;
  }

  return state.pledgeEstateForm.data;
};

export const selectPledgeEstateDictionaries = (state: TPledgeEstateState) => state.pledgeEstateForm.dictionaries;

export const selectIsPledgeEstateFormFullFilled = createSelector(selectPledgeFormInfo, (state) => state.isFullFilled);
